export default {
  EN: ['the', 'a', 'an', 'of', 'and', 'for'],
  FR: ['le', 'la', 'l\'', 'les', 'un', 'une', 'des', 'de', 'du', 'd\'', 'des', 'et'],
  GM: ['der', 'die', 'das', 'des', 'dem', 'den', 'ein', 'eine', 'einer', 'eines', 'von', 'zu', 'auf', 'und', 'fur'],
  IT: ['il', 'lo', 'la', 'l\'i', 'gli', 'le', 'un\'', 'uno', 'una', 'un', 'de', 'di', 'd\'', 'del', 'della', 'dei', 'dal', 'dalla', 'dai', 'dell\'', 'e'],
  PT: ['o', 'a', 'os', 'as', 'um', 'uma', 'uns', 'umas', 'de', 'do', 'dos', 'da', 'das', 'e'],
  SP: ['el', 'la', 'lo', 'los', 'las', 'un', 'una', 'unos', 'unas', 'de', 'y'],
  OTH: ['van', 'i'],
};
